const projects = [
  {
    title:
      "D-NAVIO: Digital Ship – Mastering Complexity of the Waterborne Digital Transport through “Cloning of the Ship”",
    url: "https://d-navio.eu",
    image: "/images/projects/d-navio.png",
    description:
      "D-NAVIO brings together artificial intelligence, maritime engineering and digital twin innovation to support safer, smarter and more sustainable waterborne transport. The project develops an Intelligent Digital Twin platform with explainable and self-healing AI capabilities, helping maritime professionals predict risks, detect anomalies, strengthen cybersecurity and improve vessel reliability across the ship lifecycle."
  },
  {
    title: "She4sea Project – Women in Blue Economy",
    url: "https://she4seaproject.eu",
    image: "/images/projects/she4sea.png",
    description:
      "She4Sea promotes the active participation of women in blue economy sectors by supporting employability, professional development and entrepreneurship. Through training, profiling tools and awareness activities, the project aims to challenge gender stereotypes, strengthen women’s career pathways and contribute to a more inclusive maritime and blue economy workforce."
  },
  {
    title: "eSgEA – Promoting ESG in the Shipping Industry",
    url: "https://esgea.eu",
    image: "/images/projects/esgea.png",
    description:
      "eSgEA supports the shipping industry in its transition towards sustainability by improving understanding of Environmental, Social and Governance principles. Through an interactive online training programme, the project helps shipping professionals and organisations integrate ESG practices, promote transparency and trust, and work towards long-term environmental and social goals."
  },
  {
    title: "Fruit Flies In-silico – Prevention & Management (FF-IPM)",
    url: "https://fruitflies-ipm.eu",
    image: "/images/projects/ffipm.png",
    description:
      "FF-IPM is a European research project focused on protecting fruit production and trade from the serious threats posed by new and emerging fruit fly species. The project develops in-silico supported approaches for prevention, detection and Integrated Pest Management, combining spatial modelling, decision-support systems and scientific knowledge on fruit fly biology, trade and socioeconomic impact."
  },
  {
    title:
      "SEASTARS – Sustainable Emission Abatement Strategies & Technologies for Advanced Revolution Ships",
    url: "https://seastars-project.eu",
    image: "/images/projects/seastars.png",
    description:
      "SEASTARS supports the decarbonisation of maritime transport by demonstrating scalable emission-reduction and energy-efficiency solutions for both retrofitted vessels and new builds. The project combines advanced modelling tools, hydrodynamic improvements, alternative fuels, hydrogen technologies, solar and wind-assisted propulsion, energy storage and carbon capture options to help shipowners design and operate greener vessels."
  },
  {
    title: "Next BlueGeneration",
    url: "https://nextbluegeneration.eu",
    image: "/images/projects/nbg.png",
    description:
      "Next BlueGeneration promotes career opportunities in the blue economy, a sector rapidly evolving through digitalisation and environmental sustainability. The project provides young people, educators and career-guidance professionals with interactive tools, training activities, webinars and learning resources that highlight pathways in maritime, aquaculture, renewable energy and other blue economy fields."
  },
  {
    title: "Bounceback",
    url: "https://bouncebackathletes.eu",
    image: "/images/projects/bounceback.png",
    description:
      "BounceBack supports veteran and retired athletes in transforming their sport-related skills into new career opportunities beyond professional sport. Through training, guidance and match-making activities, the project helps former athletes identify transferable competences, connect with the labour market and develop pathways into employment, business and entrepreneurship."
  },
  {
    title: "Media Hackers",
    url: "https://mediahackers.eu",
    image: "/images/projects/mediahackers.png",
    description:
      "Media Hackers supports journalists and media professionals in adapting to the changing digital media landscape. The project focuses on strengthening digital skills, new media competences and lifelong learning opportunities for journalists, helping them respond more effectively to technological change and evolving professional demands in the media sector."
  },
  {
    title: "Mind The Data",
    url: "https://mindthedata-project.eu",
    image: "/images/projects/mindthedata.png",
    description:
      "Mind the Data helps small and medium-sized enterprises build a sustainable data protection culture around GDPR. The project provides accessible online training material and practical tools for business consultants, legal teams, HR, marketing and operations professionals, supporting SMEs in treating data protection not only as a compliance obligation but as a source of transparency, trust and business value."
  },
  {
    title: "Beyond Inclusion",
    url: "https://beyond-inclusion.eu/",
    image: "/images/projects/beyond-inclusion.png",
    description:
      "Beyond Inclusion promotes the employment of persons with disabilities by helping SMEs recognise disability inclusion as a valuable business opportunity, not just a legal or social obligation. The project provides tools, training material, and practical guidance both for SMEs and for persons with disabilities, supporting inclusive workplaces and stronger professional self-presentation."
  },
  {
    title: "CoreVET",
    url: "https://corevet.eu/en",
    image: "/images/projects/corevet-logo.png",
    description:
      "CORE-VET supports vocational education and training in the tourism and hospitality sector, focusing on unskilled and semi-skilled people who are unemployed or already working in the industry. The project aims to strengthen professional skills, improve employability, and create better career development opportunities in a sector largely driven by small and medium-sized enterprises."
  }
];

export default projects;